import { ActivityType } from 'app/shared/model/enumerations/activity-type.model';

export interface IActivityMaster {
  id?: number;
  categoryID?: number | null;
  activityType?: keyof typeof ActivityType | null;
}

export const defaultValue: Readonly<IActivityMaster> = {};
